import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { PhaseChangeEvent } from 'app/modules/vehicle-inventory/services/inventory-reports.service';
import { Rest } from 'app/rest/rest_client';

@Component({
    selector: 'app-niif-report-form',
    templateUrl: './niif-report-form.component.html',
    styleUrls: ['./niif-report-form.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NiifReportFormComponent implements OnInit {
  client: Rest.Client;

  @Output() phaseChange = new EventEmitter<PhaseChangeEvent>();
  @Input() report: PhaseChangeEvent;

  reportData: Rest.InventoryReport;

  reportForm = new UntypedFormGroup({
    type: new UntypedFormControl(null)
  });



  types = [
    {label:this.translationService.instant("reportsWizard.niifTypes.RECORDS"), value:"RECORDS"},{label:this.translationService.instant("reportsWizard.niifTypes.ASSIGNMENTS"), value:"ASSIGNMENTS"},{label:this.translationService.instant("reportsWizard.niifTypes.EXTENSIONS"), value:"EXTENSIONS"},{label:this.translationService.instant("reportsWizard.niifTypes.CANCELLATIONS"), value:"CANCELLATIONS"},{label:this.translationService.instant("reportsWizard.niifTypes.RECALCULATION"), value:"RECALCULATION"},
  ]


  // FORM DATA
  selectedType: string;

  isTypeChanged: boolean = false;
  constructor(
    protected authenticationService: AuthenticationService,
    protected translationService: TranslateService,
  ) { }

  ngOnInit(): void {
    this.client = this.authenticationService.user.client;

    this.fetchData();
  }

  goBack() {
    this.phaseChange.emit({ phase: 1, resetData: true });
    this.reportForm.reset();
  }

  onSubmit() {
    if (this.reportForm.valid) {
      this.toPhase3();
    }
  }

  toPhase3() {
    this.phaseChange.emit({ phase: 3, reportData: this.report.reportData, formData: this.reportForm.value });
  }

  fetchData() {
    this.reportData = this.report.reportData;

  }

}
